export default "__VITE_ASSET__iqi3zR1a__"